import { formatISO, parse, parseISO } from 'date-fns';
import dateFormat from 'date-fns/format';

export const DEFAULT_DATE_FORMAT = 'MM/dd/y'; // 01/31/2020
export const DEFAULT_DATE_FORMAT_WITH_TIME = `${DEFAULT_DATE_FORMAT} 'at' hh:mma`;
export const SERVER_DATE_FORMAT = 'yyyy-MM-dd';

export const dateToFormat = (rawDate: Date, format = DEFAULT_DATE_FORMAT) =>
  dateFormat(rawDate, format);

export const parseDateFromFormat = (
  formattedDate: string,
  format = DEFAULT_DATE_FORMAT
) => parse(formattedDate, format, new Date());

export const dateISOStringToFormat = (
  dateISOString: string,
  format = DEFAULT_DATE_FORMAT
) => dateFormat(parseISO(dateISOString), format);

export const formattedDateToISO = (
  formattedDate: string,
  format = DEFAULT_DATE_FORMAT
) => formatISO(parse(formattedDate, format, new Date()));

export const dateToServer = (rawDate: Date) =>
  dateFormat(rawDate, SERVER_DATE_FORMAT);

export const parseDateFromServer = (serverDateStr: string) =>
  parse(serverDateStr, SERVER_DATE_FORMAT, new Date());

export const formattedDateToServer = (
  formattedDate: string,
  format = DEFAULT_DATE_FORMAT
) => dateToServer(parse(formattedDate, format, new Date()));

export const serverDateToFormat = (
  serverDateStr: string,
  format = DEFAULT_DATE_FORMAT
) => dateFormat(parseDateFromServer(serverDateStr), format);
